module.exports = __webpack_public_path__ + "img/no_task.5cfaddd4.png";